import React, { createContext, useContext, useEffect, useState } from "react";

const LocationContext = createContext({ isAllowed: false, loading: true });

let hasCheckedLocation = false; // outside the component — shared between renders

export const LocationProvider = ({ children }) => {
  const [isAllowed, setIsAllowed] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (hasCheckedLocation) return;
    hasCheckedLocation = true;

    const stored = sessionStorage.getItem("location-status");

    if (stored) {
      const parsed = JSON.parse(stored);
      setIsAllowed(parsed.isAllowed);
      setLoading(false);
      return;
    }

    const fetchLocation = async () => {
      try {
        const response = await fetch("/api/ipinfo");
        const data = await response.json();

        if (data?.error?.message) {
          setIsAllowed(false);
          sessionStorage.setItem(
            "location-status",
            JSON.stringify({ isAllowed: false })
          );
          return;
        }
        const blockedCountries = ["North Macedonia", "Serbia"];
        const allowed = !blockedCountries.includes(data.country);

        setIsAllowed(allowed);
        sessionStorage.setItem(
          "location-status",
          JSON.stringify({ isAllowed: allowed })
        );
      } catch (error) {
        setIsAllowed(false);
        sessionStorage.setItem(
          "location-status",
          JSON.stringify({ isAllowed: false })
        );
      } finally {
        setLoading(false);
      }
    };

    fetchLocation();
  }, []);

  return (
    <LocationContext.Provider value={{ isAllowed, loading }}>
      {children}
    </LocationContext.Provider>
  );
};

export const useLocationAllowed = () => useContext(LocationContext);
